<template>
<div class="wt-cell" :style="{'background-color': bgColor}">
  <span>{{ value }}</span><sup v-show="isComplex">*</sup><sup v-show="!isComplex"></sup>
</div>
</template>
<script>
export default {
  name: 'CChartGluDailyTableCell',
  props: {
    value: {
      type: [Number, String],
      default: () => '-'
    },
    isComplex: {
      type: [Boolean, Number],
      default: () => false      
    },
    bgColor: {
      type: [String],
      default: () => 'white'
    }
  }
}
</script>
<style lang="scss" scoped>
.wt-cell {
    text-align: center;
    box-sizing: border-box;    
    /* height: 20px; */
    /* line-height: 20px; */
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: space-around; */
    /* > * { */
    /*     display: inline-block; */
    /* } */
}  
</style>
